import { SliceCaseReducers } from '@reduxjs/toolkit/src/createSlice';
import { DataProcessingGroupByProgressProps } from '../../../types/reduxTypes/dataProcessingGroupByProgress';

const createReducer = <T extends SliceCaseReducers<DataProcessingGroupByProgressProps>>(reducer: T) => ({ ...reducer });

const reducers = createReducer({
  setDataProcessingGroupByProgressData(state, action) {
    state.dataProcessingGroupByProgressData = action.payload;
  }
});

export default reducers;
